module.exports = __webpack_public_path__ + "static/media/C (9).f9925fa7.jpg";